import ProductCombinationCard from "@components/Cards/ProductCombinationCard"
import { useIntl } from "@components/Intl"
import { productGroupToUid } from "@config/general"
import React, { FC } from "react"
import { Result } from "../types"
import { Grid } from "./elements"

type ResultsGridProps = {
  items: Result[]
}

export const combinationUids = ["rings", "bracelets", "necklaces", "earrings"]

export const ResultsGrid: FC<ResultsGridProps> = ({ items }) => {
  const { messages } = useIntl()

  return (
    <Grid>
      {items.map((item) => {
        const uid = productGroupToUid[item.product_group]
        if (uid === undefined) return null
        const as = `${messages.navigation[uid].url}/${item.slug}-${item.objectID}`
        const href = combinationUids.includes(uid)
          ? messages.navigation.collectionProductDetail.url
          : messages.navigation.separateItemsProductDetail.url
        let imageSize = undefined
        if (item.product_group && item.product_group === "stone") {
          imageSize = item.size
        }
        return (
          <ProductCombinationCard
            key={item.objectID}
            price={item.price}
            title={item.name}
            as={as}
            href={href}
            productImage={`${item.internalPreviewImage}?w=300`}
            imageSize={imageSize}
          />
        )
      })}
    </Grid>
  )
}
